import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "my-phorest/templates/accounts.hbs" })